import { taskTypesSlice } from "./taskTypesSlice";
import * as actions from "./taskTypesActions";
import * as selectors from "./taskTypesSelectors";

export { actions };
export { selectors };
export default taskTypesSlice.reducer;
